$(document).ready(function() {
    // grab the initial top offset of the navigation 
    var stickyNavTop = $('.header').offset().top;

    // our function that decides weather the navigation bar should have "fixed" css position or not.
    var stickyNav = function(){
        var scrollTop = $(window).scrollTop(); // our current vertical position from the top

        // if we've scrolled more than the navigation, change its position to fixed to stick to top,
        // otherwise change it back to relative
        if (scrollTop > stickyNavTop) { 
            $('.header').addClass('sticky2');
        } else {
            $('.header').removeClass('sticky2'); 
        }
    };

    stickyNav();

    // and run it again every time you scroll
    $(window).scroll(function() {
        stickyNav();
    });
    
    $(window).scroll(function(){ 
        if ($(this).scrollTop() > 100) { 
            $('#scroll').fadeIn(); 
        } else { 
            $('#scroll').fadeOut(); 
        } 
    }); 

    $('#scroll').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    }); 

    // Open verticals menu
    $(".hamburger-button").on("click", function() {
        $('body').toggleClass("active-overlay");
    });
    $(".overlay-close-menu").on("click", function() {
        $('body').removeClass("active-overlay");
        $('#navbar-mobile').removeClass("show");
    })

    // Tab products 
    var _collection = $(".section-tab-products .nav-item a").data("collection");
    console.log(_collection);
    // $(".section-tab-products #" + _collection).addClass("show");
});

$(window).load(function() {
    $("body").addClass("complete");

    // $('.grid').masonry({
    //     // set itemSelector so .grid-sizer is not used in layout
    //     itemSelector: '.grid-item',
    //     // use element for option
    //     // columnWidth: '.grid-sizer',
    //     percentPosition: true
    // })
});